export enum QRCodeCorrectionLevels {
  L = 'L',
  M = 'M',
  Q = 'Q',
  H = 'H',
}
